// extracted by mini-css-extract-plugin
export default {"standard":"ContentCard_standard__G6ylR","table":"ContentCard_table__9lkUs","max-height":"ContentCard_max-height__9EIbO","tasks":"ContentCard_tasks__1taW1"};